import axios from 'axios'
const service = axios.create({
  baseURL: 'https://yp.gzsckj.com.cn/receipt',
  timeout: 120000
})

service.interceptors.request.use((config) => {
  return config
}, (err) => {
  console.log(err)
  return Promise.reject(err)
})

service.interceptors.response.use((result) => {
  return result.data
}, (err) => {
  console.log(err)
  return Promise.reject(err)
})

export default service
